
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bold",
      function () {
        return require("private-next-pages/bold/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bold"])
      });
    }
  